import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css'],
  imports: [CommonModule],
})
export class TooltipComponent {
  @Input() text!: string;
  @Input() label!: string;
  isOpen = signal(false);

  handleIsOpen() {
    this.isOpen.update((state) => !state);
  }
}
